import React, { createContext, useContext } from "react";

const DisplayUserContext = createContext({ userId: null, user: null });

export const DisplayUserProvider = ({ userId, user, children }) => {
  return (
    <DisplayUserContext.Provider value={{ userId, user }}>
      {children}
    </DisplayUserContext.Provider>
  );
};

export const useDisplayUser = () => useContext(DisplayUserContext);

export default DisplayUserContext;